import React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {SmallCard} from '../../lib/small-card/small-card';


export const NotifySuccess = () => {
  const {t} = useLabelTranslation();
  return (
    <SmallCard
      title={t(
        'Thank_you_your_request_has_been_sent_to_the_host',
        'Thank you, your request has been sent to the host.',
      )}
      icon="badge-check"
      iconSemantic="success"
      testId="notify-success-small-card"
    >
      <div />
    </SmallCard>
  );
};
